import Box from '@mui/material/Box';
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Error from '../components/global/Error';
import useGetSubscription from '../hooks/subscriptions/useGetSubscription';
import PaymentMethodSection from '../components/subscriptions/PaymentMethodSection';
import PlanDetailsSection from '../components/subscriptions/PlanDetailsSection';
import BillingHistorySection from '../components/subscriptions/BillingHistorySection';
import useGetSubscriptionFromStripe from '../hooks/subscriptions/useGetSubscriptionFromStripe';
import FreeTrialAlert from '../components/subscriptions/FreeTrialAlert';
import PaymentFailedAlert from '../components/subscriptions/PaymentFailedAlert';
import PageLayout from '../components/global/PageLayout';
import { isSudoManager } from '../utils/global/helper';
import useUser from '../hooks/global/useUser';
import PageLoading from '../components/global/PageLoading';

export default function SubscriptionPage() {
  const [params, setParams] = useSearchParams();
  const { user } = useUser();

  const isSuccess = params.get('success') === 'true';
  const method = params.get('method');

  const query = useGetSubscription();
  const stripeQuery = useGetSubscriptionFromStripe();

  const isLoading = query.isLoading || stripeQuery.isLoading;
  const isRefetching = query.isRefetching || stripeQuery.isRefetching;

  const { subscription } = query.data || {};
  const { product } = stripeQuery.data || {};

  React.useEffect(() => {
    if (isSuccess && !toast.isActive('subscription-success')) {
      if (
        !method ||
        !['cancel', 'update', 'resume', 'resubscribe'].includes(method)
      )
        return;
      const message =
        method === 'update'
          ? 'Payment method updated!'
          : method === 'resume'
          ? 'Subscription resumed!'
          : method === 'resubscribe'
          ? 'Successfully resubscribed!'
          : 'Subscription canceled';
      toast.success(message, {
        toastId: 'subscription-success',
      });
      setParams(() => new URLSearchParams().toString());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (query.isError || (!isLoading && (!subscription || !product))) {
    return (
      <Box
        sx={{
          display: 'flex',
          height: 'calc(100vh - 200px)',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
        <Error errorMessage="Error fetching subscription" />
      </Box>
    );
  }

  return (
    <main>
      <PageLayout
        title="Manage Subscription"
        isLoading={isRefetching}
        guard={{
          isAllowed:
            !!user &&
            (isSudoManager(user) || user.business.type === 'INDEPENDENT'),
        }}>
        {isLoading && <PageLoading />}
        {!isLoading && (
          <>
            <FreeTrialAlert />
            <PaymentFailedAlert />
            <PaymentMethodSection />

            {!!product && <PlanDetailsSection />}

            <BillingHistorySection />
          </>
        )}
      </PageLayout>
    </main>
  );
}
